import { disputeManagementConstants } from "../_constants";

export default function disputeManagement(state = {}, action) {
    switch (action.type) {
        //dispute message
        case disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                getDisputeList: action?.user.data,
            };
        case disputeManagementConstants.GET_DISPUTEMESSAGE_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //add
        case disputeManagementConstants.CREATE_DISPUTEMESSAGE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.CREATE_DISPUTEMESSAGE_LIST_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.CREATE_DISPUTEMESSAGE_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //  update
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //delete
        case disputeManagementConstants.DELETE_DISPUTEMESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.DELETE_DISPUTEMESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case disputeManagementConstants.DELETE_DISPUTEMESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //update status
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_DISPUTEMESSAGE_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        //dispute message
        case disputeManagementConstants.GET_DISPUTECATEGORY_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_DISPUTECATEGORY_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                getDisputeCategoryList: action?.user.data,
            };
        case disputeManagementConstants.GET_DISPUTECATEGORY_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //add
        case disputeManagementConstants.CREATE_DISPUTECATEGORY_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.CREATE_DISPUTECATEGORY_LIST_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.CREATE_DISPUTECATEGORY_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //  update
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //delete
        case disputeManagementConstants.DELETE_DISPUTECATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.DELETE_DISPUTECATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case disputeManagementConstants.DELETE_DISPUTECATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //update status
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_DISPUTECATEGORY_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.GET_ADVERTISEMENT_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_ADVERTISEMENT_LIST_SUCCESS:
            return {
                ...state,

                loading: false,
                getAdvertisementList: action?.user.data,
            };
        case disputeManagementConstants.GET_ADVERTISEMENT_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //Term and tag
        case disputeManagementConstants.GET_TERMS_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_TERMS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                getTermsTagsList: action?.user.data,
            };
        case disputeManagementConstants.GET_TERMS_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //add
        case disputeManagementConstants.CREATE_TERMS_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.CREATE_TERMS_LIST_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.CREATE_TERMS_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //  update
        case disputeManagementConstants.UPDATE_TERMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_TERMS_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_TERMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //delete
        case disputeManagementConstants.DELETE_TERMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.DELETE_TERMS_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case disputeManagementConstants.DELETE_TERMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        //update status
        case disputeManagementConstants.UPDATE_TERMS_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_TERMS_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_TERMS_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.GET_DISPUTERAISEDLIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_DISPUTERAISEDLIST_SUCCESS:
            return {
                ...state,
                loading: false,
                getDisputeraisedList: action?.disputeRaised?.data,
            };
        case disputeManagementConstants.GET_DISPUTERAISEDLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.UPDATE_DISPUTEAPPEAL_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_DISPUTEAPPEAL_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_DISPUTEAPPEAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        //get
        case disputeManagementConstants.GET_COINTRADE_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_COINTRADE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                getCoinTradeList: action?.coin,
            };
        case disputeManagementConstants.GET_COINTRADE_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };



        case disputeManagementConstants.UPDATE_COINTRADE_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_COINTRADE_STATUS_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_COINTRADE_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        case disputeManagementConstants.GET_COINLIST_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_COINLIST_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                getCoinList: action?.user,
            };
        case disputeManagementConstants.GET_COINLIST_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.GET_BANK_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_BANK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                getBankList: action?.user?.data,
            };
        case disputeManagementConstants.GET_BANK_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                getTransactionDisputeList: action?.user?.data,
            };
        case disputeManagementConstants.GET_TRANSACTIONDISPUTE_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_SUCCESS:
            return {
                ...state,

                loading: false,
                error: action?.user,
            };
        case disputeManagementConstants.UPDATE_TRANSACTIONDISPUTE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        case disputeManagementConstants.GET_DISPUTESTATS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case disputeManagementConstants.GET_DISPUTESTATS_SUCCESS:
            return {
                ...state,

                loading: false,
                getMerchantDisputeStats: action?.user?.data || [],
            };
        case disputeManagementConstants.GET_DISPUTESTATS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        default:
            return state;
    }
}
